export const AiNoteInterpreter = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',

  state: {
    noteInterpretMode: 'original'
  },

  Header: {
    flow: 'x',
    align: 'center space-between',

    Title: {
      flow: 'x',
      gap: 'Y',
      align: 'center flex-start',
      AiIcon: {
        text: 'AI',
        fontSize: 'X',
        fontWeight: '800',
        padding: 'X Y',
        round: 'X',
        background: 'violet.15',
        color: 'violet'
      },
      Label: {
        text: '{{ noteInterpreter | polyglot }}',
        fontSize: 'Z',
        fontWeight: '700',
        color: 'inkText'
      }
    },

    ModeToggle: {
      flow: 'x',
      gap: '0',
      round: 'Y',
      overflow: 'hidden',
      border: '1px solid inkBorder',

      OriginalTab: {
        tag: 'button',
        text: '{{ original | polyglot }}',
        fontSize: 'Y',
        fontWeight: '600',
        padding: 'X Z',
        cursor: 'pointer',
        border: 'none',
        background: (el, s) => s.noteInterpretMode === 'original' ? 'teal' : 'ink',
        color: (el, s) => s.noteInterpretMode === 'original' ? 'white' : 'inkMuted',
        onClick: (el, s) => s.update({ noteInterpretMode: 'original' })
      },

      InterpretedTab: {
        tag: 'button',
        text: '{{ interpreted | polyglot }}',
        fontSize: 'Y',
        fontWeight: '600',
        padding: 'X Z',
        cursor: 'pointer',
        border: 'none',
        background: (el, s) => s.noteInterpretMode === 'interpreted' ? 'teal' : 'ink',
        color: (el, s) => s.noteInterpretMode === 'interpreted' ? 'white' : 'inkMuted',
        onClick: (el, s) => s.update({ noteInterpretMode: 'interpreted' })
      }
    }
  },

  NoteContent: {
    flow: 'y',
    gap: 'Y',
    padding: 'Z',
    round: 'Y',
    background: 'ink',
    minHeight: 'D',

    OriginalView: {
      show: (el, s) => s.noteInterpretMode === 'original',
      text: (el, s) => s.root.activeNoteText || '{{ noNoteSelected | polyglot }}',
      fontSize: 'Z',
      color: 'inkText',
      lineHeight: '1.5',
      whiteSpace: 'pre-wrap'
    },

    InterpretedView: {
      show: (el, s) => s.noteInterpretMode === 'interpreted',
      flow: 'y',
      gap: 'Y',

      InterpretedText: {
        tag: 'div',
        fontSize: 'Z',
        color: 'inkText',
        lineHeight: '1.5',
        whiteSpace: 'pre-wrap',
        html: (el, s) => {
          var text = s.root.activeNoteText || ''
          if (!text) return '<span style="opacity:0.5">{{ noNoteSelected | polyglot }}</span>'
          var result = el.call('normalizeTerms', text)
          if (!result || !result.changes || !result.changes.length) return text
          var output = result.normalized
          var changes = result.changes.slice().sort(function (a, b) { return b.position - a.position })
          for (var i = 0; i < changes.length; i++) {
            var c = changes[i]
            var before = output.slice(0, c.position)
            var term = output.slice(c.position, c.position + c.normalized.length)
            var after = output.slice(c.position + c.normalized.length)
            output = before +
              '<span style="background:rgba(139,92,246,0.15);padding:1px 4px;border-radius:4px;cursor:help" title="' + c.original + '">' +
              term + '</span>' + after
          }
          return output
        }
      }
    }
  },

  ChangeSummary: {
    show: (el, s) => s.noteInterpretMode === 'interpreted',
    flow: 'y',
    gap: 'X',
    padding: 'Z',
    round: 'Y',
    background: 'violet.05',
    border: '1px solid violet.15',

    SummaryLabel: {
      text: '{{ termsNormalized | polyglot }}',
      fontSize: 'Y',
      fontWeight: '700',
      color: 'violet'
    },

    ChangesList: {
      flow: 'y',
      gap: 'X',
      childExtends: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        fontSize: 'Y'
      },
      $collection: (el, s) => {
        var text = s.root.activeNoteText || ''
        if (!text) return []
        var result = el.call('normalizeTerms', text)
        if (!result || !result.changes) return []
        return result.changes.map(function (c) {
          return {
            OriginalTerm: {
              text: c.original,
              color: 'red',
              textDecoration: 'line-through',
              fontWeight: '500'
            },
            Arrow: {
              text: '\u2192',
              color: 'inkMuted'
            },
            NormalizedTerm: {
              text: c.normalized,
              color: 'green',
              fontWeight: '600'
            }
          }
        })
      }
    }
  }
}
